import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    metaInfo: {
      title: '',
      keywords: '',
      description: ''
    },
    headerContent: null, // 默认激活的标签
    headerContent1: null, // 默认激活的标签
    headerColor: null, // 默认激活的标签
    cachedData: null, //企业荣誉
    fccachedData: null, //热力风采
    dsjcachedData: null, //大事记
    whcachedData: null, //文化缓存

    partyDtcachedData: null,
    partyDwcachedData: null,
    partyLzcachedData: null,

    newsTzcachedData: null,
    newsQycachedData: null,
    newsMtcachedData: null,
    newsHycachedData: null,

    projectHrzcachedData: null,
    projectRlgwcachedData: null,
    projectXnycachedData: null,

    productCulcachedData: null,
    productSafecachedData: null,
    productPublicitycachedData: null,
    serviceSfcachedData: null,

    jobcacheData: null,
    heatAreacachedData: null
  },
  mutations: {
    CHANGE_META_INFO(state, metaInfo) {
      state.metaInfo = metaInfo
    },
    updateHeaderContent(state, tab) {
      state.headerContent = tab
    },
    updateHeaderContent1(state, tab) {
      state.headerContent1 = tab
    },
    updateHeaderColor(state, tab) {
      state.headerColor = tab
    },

    //about
    setCachedData(state, data) {
      state.cachedData = data
    },
    setFcCachedData(state, data) {
      state.fccachedData = data
    },
    setDsjCachedData(state, data) {
      state.dsjcachedData = data
    },
    setWhCachedData(state, data) {
      state.whcachedData = data
    },

    //党建
    setPartyDtCachedData(state, data) {
      state.partyDtcachedData = data
    },
    setPartyDwCachedData(state, data) {
      state.partyDwcachedData = data
    },
    setPartyLzCachedData(state, data) {
      state.partyLzcachedData = data
    },

    //news
    setNewsTzCachedData(state, data) {
      state.newsTzcachedData = data
    },
    setNewsQyCachedData(state, data) {
      state.newsQycachedData = data
    },
    setNewsMtCachedData(state, data) {
      state.newsMtcachedData = data
    },
    setNewsHyCachedData(state, data) {
      state.newsHycachedData = data
    },

    //project
    setProjectHrzCachedData(state, data) {
      state.projectHrzcachedData = data
    },
    setProjectRlgwCachedData(state, data) {
      state.projectRlgwcachedData = data
    },
    setProjectXnyCachedData(state, data) {
      state.projectXnycachedData = data
    },
    //安全生产
    setProductCulCachedData(state, data) {
      state.productCulcachedData = data
    },
    setProductSafeCachedData(state, data) {
      state.productSafecachedData = data
    },
    setProductPublicityCachedData(state, data) {
      state.productPublicitycachedData = data
    },

    setServiceSfCachedData(state, data) {
      state.serviceSfcachedData = data
    },
    //联系我们
    setJobCachedData(state, data) {
      state.jobcacheData = data
    },
    setHeatAreaCachedData(state, data) {
      state.heatAreacachedData = data
    }
  },
  actions: {
    //about
    cachedData({ commit }, data) {
      commit('setCachedData', data)
    },
    fccachedData({ commit }, data) {
      commit('setFcCachedData', data)
    },
    dsjcachedData({ commit }, data) {
      commit('setDsjCachedData', data)
    },
    whcachedData({ commit }, data) {
      commit('setWhCachedData', data)
    },
    //party
    partyDtcachedData({ commit }, data) {
      commit('setPartyDtCachedData', data)
    },
    partyDwcachedData({ commit }, data) {
      commit('setPartyDwCachedData', data)
    },
    partyLzcachedData({ commit }, data) {
      commit('setPartyLzCachedData', data)
    },
    //news projecthrzcacheData
    newsTzcachedData({ commit }, data) {
      commit('setNewsTzCachedData', data)
    },
    newsQycachedData({ commit }, data) {
      commit('setNewsQyCachedData', data)
    },
    newsMtcachedData({ commit }, data) {
      commit('setNewsMtCachedData', data)
    },
    newsHycachedData({ commit }, data) {
      commit('setNewsHyCachedData', data)
    },
    //project
    projectHrzcachedData({ commit }, data) {
      commit('setProjectHrzCachedData', data)
    },
    projectRlgwcachedData({ commit }, data) {
      commit('setProjectRlgwCachedData', data)
    },
    projectXnycachedData({ commit }, data) {
      commit('setProjectXnyCachedData', data)
    },
    //安全生产
    productCulcachedData({ commit }, data) {
      commit('setProductCulCachedData', data)
    },
    productSafecachedData({ commit }, data) {
      commit('setProductSafeCachedData', data)
    },
    productPublicitycachedData({ commit }, data) {
      commit('setProductPublicityCachedData', data)
    },
    serviceSfcachedData({ commit }, data) {
      commit('setServiceSfCachedData', data)
    },
    //联系我们serviceSfcachedData
    jobcacheData({ commit }, data) {
      commit('setJobCachedData', data)
    },
    heatAreacacheData({ commit }, data) {
      commit('setHeatAreaCachedData', data)
    }
  },

  getters: {
    headerContent: state => state.headerContent
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js